export default __webpack_public_path__ + "static/media/18-ART-(5-3).4c9f4708.jpg";